var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.visible)?_c('div',[_c('xx-image-viewer',_vm._b({attrs:{"on-close":_vm.close}},'xx-image-viewer',_vm.$attrs,false))],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }